export default "__VITE_ASSET__DcH41NT3__"